import { getJSON } from 'js-cookie';
import { Lang } from 'src/types';

export const getCookieValue = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length > 1 ? parts.pop()?.split(';').shift() : false;
};

export const setFootfallCookie = (cookie: object) => {
  document.cookie = `FOOTFALL_SESSION=${encodeURIComponent(JSON.stringify(cookie))}; path=/; expires=${getExpiryDate()}`;
};

const getExpiryDate = () => {
  // 1 year (365*24*60*60*1000 ms)
  return new Date((new Date()).getTime() + (365 * 24 * 60 * 60 * 1000)).toUTCString();
};

export const setReferrerCookie = (referrer: string) => {
  if (referrer === getCookieValue('huReferrer')) return;
  document.cookie = `huReferrer=${referrer}; path=/; expires=${getExpiryDate()}`;
};

export const getBranch = () => {
  const huBv = getCookieValue('huBv');
  return huBv ? huBv.charAt(0).toUpperCase() : 'A';
};

export const getLangCookie = () => getCookieValue('huLang');

export const setLangCookie = (lang: Lang) => {
  document.cookie = `huLang=${lang}; path=/; expires=${getExpiryDate()}`;
};

export const getFunctionalityCookiesConsent = () => {
  const ccCookie = document.cookie.match(new RegExp('(^|;\\s*)(CookieControl)=([^;]*)'));
  if (ccCookie) {
    const ccCookieValue = ccCookie.pop();
    if (ccCookieValue?.includes('functionality":"accepted')) {
      window.isFunctionalityEnabled = true;
    } else {
      // No consent given yet or the user rejected functionality cookies
      window.isFunctionalityEnabled = false;
    }
  } else {
    // Cookie doesn't exist yet and the user needs to give consent
    window.isFunctionalityEnabled = false;
  }
};

export const isAnalyticsAccepted = () => {
  const ccCookie = getJSON('CookieControl');
  return ccCookie?.optionalCookies?.analytics === 'accepted' ? true : false;
};
